import { render, staticRenderFns } from "./FormStaff.vue?vue&type=template&id=1c5d1d06&scoped=true"
import script from "./FormStaff.vue?vue&type=script&lang=js"
export * from "./FormStaff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5d1d06",
  null
  
)

export default component.exports